// Collection Slider -> native Wonder Theme cart integration
(function () {
  if (window.__cgwsNativeCartFixInstalled) return;
  window.__cgwsNativeCartFixInstalled = true;

  document.addEventListener('submit', async function (event) {
    var form = event.target.closest('.cgws-add-form');
    if (!form) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    var button = form.querySelector('.cgws-add-btn');
    if (!button || button.disabled) return;

    var originalText = button.textContent;
    var cart = document.querySelector('cart-drawer');
    var cartType = cart && cart.dataset ? cart.dataset.cartType : 'page';

    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');
    button.textContent = 'Adding...';

    try {
      var formData = new FormData(form);

      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.append(
          'sections',
          cart.getSectionsToRender().map(function (section) { return section.id; })
        );
      }

      formData.append('sections_url', window.location.pathname);

      var config = typeof fetchConfig === 'function'
        ? fetchConfig('javascript')
        : {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            }
          };

      config.method = 'POST';
      config.headers = config.headers || {};
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;

      var response = await fetch(
        (window.routes && window.routes.cart_add_url) || '/cart/add.js',
        config
      );
      var data = await response.json();

      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || 'Cart error');
      }

      if (
        typeof publish === 'function' &&
        window.PUB_SUB_EVENTS &&
        PUB_SUB_EVENTS.cartUpdate
      ) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'collection-slider',
          productVariantId: formData.get('id'),
          cartData: data
        });
      }

      var isClosedCart = !document.body.classList.contains('page-overlay-cart-on');

      if (
        cartType === 'drawer' &&
        cart &&
        typeof cart.renderContents === 'function' &&
        data.sections
      ) {
        cart.renderContents(data, isClosedCart);
      } else {
        document.dispatchEvent(
          new CustomEvent('cart-drawer:refresh', {
            bubbles: true,
            composed: true
          })
        );
      }

      button.textContent = 'Added ✓';
    } catch (error) {
      console.error('Collection Slider add to cart:', error);
      button.textContent = 'Error!';
      document.dispatchEvent(
        new CustomEvent('cart-drawer:refresh', {
          bubbles: true,
          composed: true
        })
      );
    } finally {
      setTimeout(function () {
        button.textContent = originalText;
        button.disabled = false;
        button.removeAttribute('aria-disabled');
      }, 900);
    }
  }, true);
})();
